import loadImage from 'blueimp-load-image';

import { UPLOAD_SERVICE_BASE_URL } from 'constants/image';

import { isEmpty, isString } from './helpers';

export const scale = function (file, width, height) {
  return loadImage.scale(file, {
    maxWidth: width,
    minWidth: width,
    maxHeight: height,
    minHeight: height,
    canvas: true,
    crop: true,
    downsamplingRatio: 0.5,
  });
};

export const load = function (
  file,
  options = {
    canvas: false,
    noRevoke: true,
    meta: false,
  }
) {
  return new Promise((resolve, reject) => {
    loadImage(
      file,
      image => {
        if (image.type === 'error') {
          reject(image);
        } else {
          resolve(image);
        }
      },
      options
    );
  });
};

const fileNameRegExp = /(.*?)(\..*)?$/;

/*
  With only `file` just return original image.
  If `isFullView` is true then return resized image with original ratio
  else return cropped image with specified width and height.
*/
export const getImageUrl = (file, ...args) => {
  const [width, height, isFullView] = args;
  if (!file || isEmpty(file)) {
    return file;
  }
  let fileName;
  if (isString(file)) {
    fileName = file;
  } else if (file.path) {
    fileName = file.path;
  } else if (file.id) {
    fileName = file.id;
  } else if (file.file instanceof File || file.file instanceof Blob) {
    return URL.createObjectURL(file.file);
  } else {
    return;
  }
  const [, path, extension] = fileNameRegExp.exec(fileName);

  let url = `${UPLOAD_SERVICE_BASE_URL}/${path}`;
  const { crop } = file;
  if (crop) {
    url += `/-/extract/${crop.x}x${crop.y}x${crop.width}x${crop.height}/`;
  }
  if (!isFullView && width && height) {
    if (!crop) {
      url += `/`;
    }
    url += `-/resize/${width}x${height}/`;
  }

  return url + (extension || '');
};

export const getBaseImageUrl = file => {
  if (!file || isEmpty(file)) {
    return file;
  }
  let fileName;
  if (isString(file)) {
    fileName = file;
  } else if (file.path) {
    fileName = file.path;
  } else if (file.id) {
    fileName = file.id;
  } else if (file.file instanceof File || file.file instanceof Blob) {
    return URL.createObjectURL(file.file);
  } else {
    return;
  }
  const [, path] = fileNameRegExp.exec(fileName);

  return `${UPLOAD_SERVICE_BASE_URL}/${path}`;
};

export const getPercentImageAspectRatio = aspectRation => aspectRation * 100;

export const getGalleryAverageColor = gallery => {
  const firstLoaded = gallery.find(image => image.averageColor);
  return firstLoaded ? '#' + firstLoaded.averageColor : '';
};
